import HTTP from "@/_helpers/http";
import { NEWS__API } from "@/_helpers/urls";
import { NEWS__MUTATIONS } from "../mutation-types";
import { NEWS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  news: [],
  pagination: {
    page: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 10,
  },
  isLoading: false,
};

const mutations = {
  SET_NEWS(state, payload) {
    state.news = payload.data;
    state.pagination = payload.pagination;
  },
  SET_LOADING(state, status) {
    state.isLoading = status;
  },
};

const actions = {
  async [NEWS__ACTIONS.GETNEWS]({ commit }, { page = 1, limit = 10 } = {}) {
    try {
      commit("SET_LOADING", true);

      const response = await HTTP().get(
        `${NEWS__API.GETNEWS}?page=${page}&limit=${limit}`
      );

      if (response.data.success) {
        commit("SET_NEWS", response.data);
      }
    } catch (error) {
      console.error("Pagination GETNEWS error:", error);
      toast.error("Failed to load news");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async [NEWS__ACTIONS.VIEWNEWSDETAILS]({ commit }, id) {
    return await HTTP().get(NEWS__API.VIEWNEWSDETAILS(id));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
